import cn from 'classnames';

import { type CategoryNavProps } from './CategoryNav.types';

const CategoryNav: React.FC<CategoryNavProps> = ({ pages }) => {
  if (!pages || pages.length === 0) return;

  const hasOneHighlighted =
    pages.filter((page) => page.linkingMode !== 'link').length > 0;

  return (
    <ul className="category-nav">
      {pages.map((page, i) => {
        const isCurrent =
          page.linkingMode !== 'link' || (!hasOneHighlighted && i === 0);

        return (
          <li className="category-nav__item" key={i}>
            <a
              href={page.url}
              className={cn('category-nav__link', {
                'category-nav__link--active': isCurrent,
              })}
              aria-current={isCurrent ? 'page' : undefined}
            >
              {page.title}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default CategoryNav;
